import React from 'react'

const DiscoverySuiteDescription = (): React.ReactNode => (
  <>
    {' '}
    Discovery suite lets you auto-tag tracks, share your whole catalog, search
    for similar tracks and generate instrumentals.
    <br />
    Includes{' '}
    <a
      className="AddOns_Link"
      href="https://www.disco.ac/catalogs"
      target="_blank"
      rel="noopener noreferrer"
    >
      Catalogs
    </a>
    ,{' '}
    <a
      className="AddOns_Link"
      href="https://www.disco.ac/similarity-search"
      target="_blank"
      rel="noopener noreferrer"
    >
      Similarity Search
    </a>
    ,{' '}
    <a
      className="AddOns_Link"
      href="https://www.disco.ac/auto-tagging"
      target="_blank"
      rel="noopener noreferrer"
    >
      Auto-tagging
    </a>{' '}
    and{' '}
    <a
      className="AddOns_Link"
      href="https://www.disco.ac/instant-instrumental"
      target="_blank"
      rel="noopener noreferrer"
    >
      Instant Instrumental
    </a>
    . On the Pro plan or above, Discovery Suite unlocks{' '}
    <a
      className="AddOns_Link"
      href="https://www.disco.ac/feature-lyric-transcription"
      target="_blank"
      rel="noopener noreferrer"
    >
      Lyric Transcription
    </a>
    . This add-on is in addition to your base plan and will be billed in the
    same billing cycle.
  </>
)

export default DiscoverySuiteDescription
